import * as Sentry from '@sentry/react';

type InitSentryOptions = {
  dsn?: string;
  environment?: string;
  release?: string;
};

/**
 * Initializes Sentry error tracking + browser performance tracing. Call once
 * at app startup, before rendering the root component.
 *
 * No-ops if `dsn` is unset (e.g. local development).
 */
export function initSentry(options: InitSentryOptions): void {
  const { dsn, environment, release } = options;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment,
    release,
    integrations: [Sentry.browserTracingIntegration()],
    // Full sampling in dev/staging; low sampling in production to control cost.
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
  });
}

export { Sentry };
